import { Box } from '@mui/system';

export const CustomPlayer = ({ url, height, minWidth, autoPlay=false }: { url: string; height?: string, minWidth?: string, autoPlay?: boolean }) => {
  return (
    <Box display={'flex'} justifyContent={'center'} alignItems={'center'}>
      <video
        key={url}
        className="react-player"
        autoPlay={autoPlay}
        preload="metadata"
        controlsList="nodownload"
        controls
        style={{
          background: '#000',
          borderRadius: '16px',
          height,
          width: '100%',
          minWidth: minWidth ? minWidth : '',
          padding: '16px 0',
        }}
      >
        {/* First source for .mp4 format */}
        <source src={url} type="video/mp4" />
        {/* Second source for .mov format */}
        <source src={url} type="video/quicktime" />
        Your browser does not support this video.
      </video>
    </Box>
  );
};
